import {
  PlaceTypeEnum,
  SearchEntityTagOperatorEnum,
  SearchUserEntityTagInput,
  UserSearchEntityTagNameEnum,
} from '@src/graphql/generated';
import { idify } from '@src/util/idify';
import { RELOCATION_OPTION, REMOTE_OPTION } from '@src/containers/CountrySelect';
import { QueryParams } from '../interfaces/queryParams.interface';
import { DEFAULT_SPECIALITY_KEY } from '../constants/filters';
import { DateRange, GetSearchTagsValue } from './interfaces/getSearchTags.interface';

export const getSearchTags = (queryParams: QueryParams, dataRange?: DateRange): GetSearchTagsValue => {
  const { place, speciality, searchPatterns = [], isRelocation, isRemote } = queryParams;

  const placeSearchTags: SearchUserEntityTagInput[] = [];

  if (place && place.id !== REMOTE_OPTION.id && place.id !== RELOCATION_OPTION.id) {
    if (place.type === PlaceTypeEnum.LOCATION) {
      placeSearchTags.push({
        tag: UserSearchEntityTagNameEnum.LOCATION,
        value: idify(place),
      });
    } else if (place.type === PlaceTypeEnum.COUNTRY) {
      placeSearchTags.push({
        tag: UserSearchEntityTagNameEnum.COUNTRY,
        value: idify(place),
      });
    }
  }

  if ((place && place.id === REMOTE_OPTION.id) || isRemote) {
    placeSearchTags.push({
      tag: UserSearchEntityTagNameEnum.REMOTE,
      value: true,
    });
  }

  if ((place && place.id === RELOCATION_OPTION.id) || isRelocation) {
    placeSearchTags.push({
      tag: UserSearchEntityTagNameEnum.RELOCATION,
      value: 'true',
    });
  }

  const specialitySearchTags: SearchUserEntityTagInput[] =
    speciality && speciality !== DEFAULT_SPECIALITY_KEY
      ? [
          {
            tag: UserSearchEntityTagNameEnum.SPECIALITY,
            value: speciality,
          },
        ]
      : [];

  const verificationPublishedAtSearchTags: SearchUserEntityTagInput[] = [];

  const searchPatternSearchTags: SearchUserEntityTagInput[] = searchPatterns.map(item => ({
    operator: SearchEntityTagOperatorEnum.SEARCH_PHRASE,
    tag: UserSearchEntityTagNameEnum.NAME,
    value: item.pattern,
  }));

  if (dataRange?.joinedFrom) {
    verificationPublishedAtSearchTags.push({
      operator: SearchEntityTagOperatorEnum.GT,
      tag: UserSearchEntityTagNameEnum.VERIFICATION_PUBLISHED_AT,
      value: dataRange.joinedFrom,
    });
  }

  if (dataRange?.joinedTo) {
    verificationPublishedAtSearchTags.push({
      operator: SearchEntityTagOperatorEnum.LT,
      tag: UserSearchEntityTagNameEnum.VERIFICATION_PUBLISHED_AT,
      value: dataRange.joinedTo,
    });
  }

  return {
    searchTagsWithAndCondition: [...placeSearchTags, ...verificationPublishedAtSearchTags, ...searchPatternSearchTags],
    searchTagsWithOrCondition: [...specialitySearchTags],
  };
};
